/* eslint-disable react-hooks/exhaustive-deps */
import { get, map, find } from "lodash";
import slice from "lodash/slice";
import { ArticleContext } from "providers/Article";
import { AssetsContext } from "providers/Assets";
import { PagesContext } from "providers/Pages";
import { ServerSidePropsContext } from "providers/ServerSideProps";
import { SessionDataContext } from "providers/Session";
import React, { useContext, useEffect, useState } from "react";

import Article from "../Article/Article.index";
import { ComponentSwitch } from "./Base.index";
import AdsSlot from "../Ads/Ads.Slot";
import SessionAlertModal from "components/Article/SessionAlert/SessionAlertModal";
import { getSessionDataFromCookie } from "providers/Session/utils";
import { useKeycloak } from "@react-keycloak/ssr";
import { KeycloakInstance } from "keycloak-js";

const getItem = (slotsData, slotList) => {
  const items: Array<{}> = [];
  map(slotList, (item) => {
    const policy = { id: item.replace("contentid/", "policy:") };
    const found = find(slotsData, policy);
    found && items.push(found);
  });
  return items;
};

const getArticleInnerProps = (article) => {
  const articleData = get(article, "pageDataArticleElement", false);
  const articleImageTop = get(article, "showTopImage", false);
  const articleImageBottom = get(article, "showImageBottom", false);
  const showImageBottom =
    articleImageBottom || get(articleData, "showImageBottom", true);
  const showListenButton = get(articleData, "showListenButton", true);
  const showMainTitle = get(articleData, "showMainTitle", true);
  const showTopImage =
    articleImageTop && get(articleData, "showImageTop", false);
  const showImageFull = get(articleData, "showImageFull", false);
  return {
    showImageBottom,
    showListenButton,
    showMainTitle,
    showImageFull,
    showTopImage,
  };
};

const renderSlotInner = (article, relatedList, slotName) => {
  const articleData = get(article, "pageDataArticleElement", false);
  let slotData;
  if (articleData) {
    let contentData = get(articleData, "contentData", []);
    slotData = getItem(contentData, get(articleData, slotName, []));
  }
  return map(slotData, (data, key) => {
    if (data?.name === "Leia também") {
      const ids = map(relatedList, (i) => i.id);
      data = {
        ...data,
        items: [...data.items, ...relatedList],
        slotAutoLeftElements: [...data.slotAutoLeftElements, ...ids],
      };
    }
    return <ComponentSwitch data={data} key={key} />;
  });
};

const ArticleComponent = ({ title }) => {
  const articleContext = useContext(ArticleContext);
  const assetsState = useContext(AssetsContext);
  const pagesContext = useContext(PagesContext);
  const serverSideContext = useContext(ServerSidePropsContext);
  const { keycloak } = useKeycloak<KeycloakInstance>();
  const articleProps = get(assetsState, "assets.article");
  const sessionReadingLimit = keycloak?.tokenParsed?.exp;
  const isPaywall =
    serverSideContext?.site?.pageConfig?.featureRadioSelectPaywall;

  useEffect(() => {
    articleContext.setIsLoaded(true);
    return () => {
      articleContext.clearState();
    };
  }, []);

  const { articles } = articleContext;
  const firstArticle = articles && articles.length > 0 ? articles[0] : false;
  const articleRelatedList = firstArticle
    ? firstArticle?.relatedArticleList
    : [];
  const [showModal, setShowModal] = useState(false);
  const sessionData = getSessionDataFromCookie();
  const articleRelatedSlice = (i) => {
    const start = (i + 1) * 3;
    const end = (i + 2) * 3;
    const list = slice(articleRelatedList, start, end);
    return list;
  };
  const handleAutoLogout = () => {
    if (sessionData?.ativo === false && !showModal) {
      setShowModal(true);
    }
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (!showModal) {
        handleAutoLogout();
      }
    }, 10000);
    return () => clearInterval(interval);
  }, [sessionData?.ativo]);
  return (
    <div>
      {/* {showModal && (
        <SessionAlertModal
          subTitle="Todas as suas licenças já estão sendo usadas neste momento!"
          message="Clique em entrar para logar novamente e desconectar as outras sessões."
          info="Em caso de dúvida, entre em contato com nosso Serviço de Atendimento ao Assinante: (62) 3250 1220"
          onClose={handleCloseModal}
        />
      )} */}
      {articles.map((article: any, key) => (
        <div
          data-article-id={article.id}
          data-article-url={article.path}
          data-component-type="article"
          key={`article-wrapper-${article.id}`}
        >
          {renderSlotInner(article, [], "slotAutoLeftElements")}
          <Article
            {...articleProps}
            {...article}
            {...getArticleInnerProps(article)}
            id={article.id}
            domain={pagesContext.domain}
            key={`article-${article.id}`}
            itemPosition={key}
            isPaywall={isPaywall}
            sessionReadingLimit={sessionReadingLimit}
            sessionPremium={
              isPaywall == "DESATIVADO" ? false : article.isLocked
            }
            articleType={title}
          />
          {renderSlotInner(
            article,
            articleRelatedSlice(key),
            "slotManualLeftElements"
          )}
          <AdsSlot
            type="article"
            componentReference="bottom"
            data={{ article: article, key: key }}
          />
        </div>
      ))}
    </div>
  );
};

export default ArticleComponent;
